export default {
    totalItems: state => state.totalItems,
    users: state => state.users,
    rowsPerPage: state => state.pagination.rowsPerPage,
    pagination: state => state.pagination
}
